module.exports = __webpack_public_path__ + "media/assets/images/logos/logo_energia-59e176958e7a9ae958bacd6e6c2123d2.png";